import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step, { StepProps } from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import {
  Button,
  CircularProgress,
  StepConnector,
  stepConnectorClasses,
  StepIcon,
} from "@mui/material";
import styled from "@emotion/styled";
import "./stepper.scss";
import { Cancel } from "@mui/icons-material";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import Icons from "../Icons";

import i18n from "../../i18n";

import { useContext, useState } from 'react';
import '../../../src/components/availabilityTasks/AvailabilityTasks.scss';
import coins from '../../assests/images/coins.svg'
import icon from '../../assests/images/step1-icon.svg'
import uploadImg from '../../assests/images/uploadImg.svg'
import UploadPack2 from '../../assests/images/cig_pack_img.svg'
import CameraCapture from '../camera';
import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";

const QontoConnector = styled(StepConnector)(({ theme }: any) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
    left: "calc(-50% + 10px)",
    right: "calc(50% + 10px)",
    zIndex: "1",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#C8172F",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#C8172F",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#FFEBEF",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));
const StyledStepper = styled(Stepper)(({ theme }: any) => ({
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));
interface StyledStepProps extends StepProps {
  error?: boolean; // Add the error prop as optional
}

const StyledStep = styled(Step)<StyledStepProps>(({ theme, error }) =>
  css({
    background: "#FFFFFF",
    padding: "12px 0px !important",
    ".MuiSvgIcon-root": {
      borderRadius: "30px",
      border: "1px solid #C5C6C7",
      background: "#F5F6F7",
      color: "transparent",
      "&.Mui-active": {
        borderRadius: "30px",
        border: "1px solid #C8172F",
        background: "#FFEBEF",
        color: "transparent",
        ".MuiStepIcon-text": {
          fill: "#C8172F",
        },
      },
      "&.Mui-completed": {
        color: "#46C65A",
        border: "0",
      },
      ".MuiStepIcon-text": {
        fill: "#7D7E7F",
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "normal",
        letterSpacing: "0.12px",
      },
    },
    ".MuiStepLabel-labelContainer": {
      ".MuiStepLabel-label": {
        color: "#7D7E7F",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        letterSpacing: "0.12px",
        marginTop: "4px",
        ".points_count": {
          display: "block",
          color: "#7D7E7F",
          textAlign: "center",
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "18px",
          letterSpacing: "0.12px",
          ".error": {
            color: "#C8172F",
          },
        },
        ".error": {
          color: "#C8172F",
        },
      },
    },
    // Apply conditional styles based on the error prop
    ...(error && {
      ".MuiSvgIcon-root": {
        color: "#C8172F",
      },
      ".MuiStepLabel-labelContainer .MuiStepLabel-label": {
        color: "#C8172F", // Change label color if there's an error
      },
    }),
  })
);

const StyledStepLabel = styled(StepLabel)(({ theme }: any) => ({
  [theme.breakpoints.down("sm")]: {
    // Custom styles for step labels in mobile
    fontSize: "1rem",
  },
}));

export default function AvaliabilityCustomStepper({ questData }: any) {


  function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}
const buildImageUrl = (path?: string | null) => {
  if (!path) return null;

  // Already full URL → use directly
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Otherwise prefix base URL
  return `${process.env.REACT_APP_BASE_URL_image}${path}`;
};
// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
const t = (key: string, vars?: Record<string, any>): string => {
  let text = translate(translations, key) || key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(`{{${k}}}`, String(v));
    });
  }
  return text;
};
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [isStepFailed, setIsStepFailed] = React.useState<Array<number | null>>(
    []
  );
  const [submitBtnName, setSubmitBtnName] = React.useState<string>(t('taskdetaitls.educational.quest_submit_btn'));
  const [isDirty, setIsDirty] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const steps =
    questData?.data?.subtasks?.map((subtask: any) => ({
      qno: subtask?.question_no,
      qid: subtask?.question_id,
      points: subtask?.points,
      quest: subtask?.question,
      opts: subtask?.options.map((option: any) => option.option_value),
      ans: subtask?.options.find((option: any) => option.correct_option === "1")
        ?.option_value,
      hint: subtask?.hint?.content_type,
    })) || [];

  const isStepOptional = (step: number) => {
    return step === 4;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };


  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const encryptedTaskId = window.btoa(questData.data.task_id.toString());
  console.log('AvailabilityTasks', questData)
  const [label, setlabel] = useState([t("taskdetaitls.availability.sample_img_label"), t("taskdetaitls.availability.sample_img_label")])

  const tasks = questData?.data?.subtasks?.map((subtask: any, index: number) => ({
    subtitle: subtask?.question,
    question_id: subtask?.question_id,
    sampleImage: buildImageUrl(subtask?.sample_picture),
    task_id: subtask?.task_id,
    reward: `${t('earn_pnts.points_earn', { points: subtask.points || 0 })}`,
    steps: subtask?.hint?.steps?.map((step: any) => ({
      step: `${t('taskdetaitls.availability.step_label')} ${step.step_number}`,
      description: step.step_text,
      // icon: step.step_icon || null,
      icon: buildImageUrl(step?.step_icon),
    })) || [],
    sample_picture: subtask?.hint?.sample_image || (index === 0 ? uploadImg : UploadPack2),
    takeAPic: subtask?.options[0].option_value
  })) || [];

  const [imagesCaptured, setImagesCaptured] = useState<boolean[]>(
    Array(tasks.length).fill(false)
  );
  const [images, setImages] = useState<Array<{
    task_id: string,
    question_id: string,
    answer: string,
    no_of_attempts: string,
    is_correct: string,
  }>>([]
  );


  const handleCapture = (index: number, captured: boolean, question_id: string) => {
    const updatedImages = [...imagesCaptured];
    const labels = [...label];
    updatedImages[index] = captured;
    labels[index] = t("taskdetaitls.availability.clicked_img_label");
    setImagesCaptured(updatedImages);
    setlabel(labels);
    setIsDirty(true);
  };
  

  const storeAnswers = async (images: any) => {
         const tokenn = localStorage.getItem("token");

    if (authContext) {
      const { token } = authContext;
      
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/answer/store-answer`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenn}`,
            'Accept-Language': i18n.language,
          },
          body: JSON.stringify(images),
        }
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to store answers: ${errorText}`);
      }
      return response.json();
    }
  };


  const handleNext = async (ansData: any) => {
    setLoading(true);
    try {
      setIsDirty(false);
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    } catch (error) {
      console.error("Error storing answers:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (ansData: any) => {
    setLoading(true);
    if (activeStep === steps.length - 1) {
      try {
        await storeAnswers(ansData);
        navigate(`/points/${encryptedTaskId}`);
      } catch (error) {
        console.error("Error submitting answers:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box sx={{
      width: "100%",
    }}>
      <>
        <StyledStepper
          connector={<QontoConnector />}
          activeStep={activeStep}
          alternativeLabel
        >
          {steps.map(({ qno, points }: any, index: any) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
              error?: boolean;
              icon?: any;
              color?: string;
            } = {
              color: "#C8172F",
            };
            if (isStepOptional(index)) {
              labelProps.optional = (
                <Typography variant="caption">Optional</Typography>
              );
            }
            if (isStepFailed.includes(index - 1)) {
              labelProps.color = "error";
              labelProps.error = true;
              labelProps.icon = (
                <StepIcon
                  style={{ color: "red" }}
                  icon={<Cancel color="error" />}
                />
              );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <StyledStep
                error={isStepFailed.includes(index - 1)}
                key={qno}
                {...stepProps}
              >
                <StyledStepLabel {...labelProps}>
                  <span
                    className={`${isStepFailed.includes(index - 1) && "error"
                      }`}
                  >{`Question ${qno}`}</span>
                  <span
                    className={`points_count ${isStepFailed.includes(index - 1) && "error"
                      }`}
                  >{`${points}pts`}</span>
                </StyledStepLabel>
              </StyledStep>
            );
          })}
        </StyledStepper>
        <React.Fragment>
          {/* content */}
          <Box className="steps">
            {tasks.map((task: any, index: any) => (
              activeStep === index && (
                <Box key={index} sx={{ background: '#FFFFFF', borderRadius: '12px', margin: '20px 0', textAlign: 'left' }}>
                  <Box className="cardHead" sx={{
                    borderBottom: '1px dashed #C5C6C7',
                    display: 'flex',
                    padding: '16px 10px',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <Typography variant='body2'>
                      {`${t('taskdetaitls.availability.picture')} ${index + 1}`} :
                      <span style={{ marginLeft: "4px" }}>{task.subtitle}</span>
                    </Typography>
                    <Box sx={{
                      borderRadius: '40px',
                      border: '1px solid #E8E8E8',
                      background: '#F5F6F7',
                      display: 'flex',
                      padding: '4px 8px',
                      alignItems: 'center',
                      gap: '4px'
                    }}>
                      <img src={coins} alt="" />
                      <Typography variant='caption1' sx={{ fontWeight: '700' }}>{task.reward}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ padding: '12px 16px 0px 16px', gap: '12px', display: 'flex', flexDirection: 'column' }}>
                    {task.steps.map((step: any, stepIndex: any) => (
                      <Box key={stepIndex} sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Box sx={{
                          width: '100%',
                          maxWidth: '56px',
                          height: '56px',
                          backgroundColor: '#FFEBEF',
                          zIndex: "10000",
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          {/* <Icons name={step.icon} /> */}
                          <img
  crossOrigin="anonymous"
  src={step?.icon || "/default-icon.png"}
  alt="Step Icon"
/>

                        </Box>
                        <Box sx={{ textAlign: 'left' }}>
                          <Typography variant='caption1' sx={{ color: '#7D7E7F', fontWeight: '600' }}>{step.step}</Typography>
                          <Typography variant='body2' sx={{ fontWeight: '600', lineHeight: 'normal' }}>{step.description}</Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  <Typography variant='body2' sx={{
                    fontWeight: '700',
                    letterSpacing: '0.14px',
                    padding: '16px 10px',
                    borderBottom: '1px dashed #C5C6C7',
                    marginTop: '8px'
                  }}>{label[index]}</Typography>
                  <CameraCapture
                    data={task}
                    defaultImage={task.sampleImage}
                    setImages={setImages}
                    images={images}
                    onCapture={(captured) => handleCapture(index, captured, task.question_id)}
                  />
                </Box>
              )
            ))}
          </Box>
        </React.Fragment>
        <Box className="foot">
          <Button
            type="submit"
            disabled={loading ? isDirty : !isDirty}
            className="btn_red"
            onClick={async () => {
              if (activeStep === steps.length - 1) {
                await handleSubmit(images);
              } else {
                await handleNext(images);
              }
            }}
          >
            {activeStep === steps.length - 1 ? t('taskdetaitls.educational.result_btn') : t('taskdetaitls.educational.next_btn')}
            {loading ? (
              <CircularProgress
                sx={{
                  color: "white",
                  height: "20px !important",
                  width: "20px !important",
                  marginLeft: "8px",
                }}
              />
            ) : (
              ""
            )}
          </Button>
        </Box>
      </>
    </Box>
  );
}
